import { API_VERSION_ESYMANDANT, fetchHandler, fetchRequestBuilder, HTTP_METHOD, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const getPublicFileInfo = (accountId, storage) => {
    const request = fetchRequestBuilder(API_VERSION_ESYMANDANT + `/e.consult.${accountId}/files/upload/info`, HTTP_METHOD.GET, {}, true, false, false, storage)
    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}